export default __webpack_public_path__ + "static/media/PANEL_4_ICONOS.7012c62b.png";